import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../network/apiClient';
import { countriesUrl } from '../definition/API';

const fetchCountries = createAsyncThunk(
  'countries/fetchCountries',
  async () => {
    try {
      /* eslint-enable @typescript-eslint/naming-convention */
      const response = await apiClient(countriesUrl);

      if (response.status >= 400) {
        throw new Error(response.data.message || 'Invalid response!');
      }

      return {
        data: response.data.data || [],
      };
    } catch (error) {
      throw new Error(error as string);
    }
  }
);

export default fetchCountries;
